// for links with special characters
function slugify(text) {
  return text
    .toLowerCase()
    .replace(/&/g, "and") // Replace & with 'and'
    .replace(/[\s\W-]+/g, "-") // Replace spaces and non-word chars with -
    .replace(/^-+|-+$/g, ""); // Trim leading/trailing -
}

// appends the tab name as an anchor tag
function updateUrl(e) {
  const tabText = e.currentTarget.querySelector("span").textContent.trim();
  const newTabName = slugify(tabText);
  window.location.hash = newTabName;
}

function handleHashChange() {
  const tabName = window.location.hash.replace("#", "");
  const tabButtons = document.querySelectorAll('[data-fndry-js="nav-link"]');
  const tabPanes = document.querySelectorAll(".fndry-tabs__tab-pane");
  const tabNames = Array.from(tabButtons).map((button) => slugify(button.querySelector("span").textContent.trim()));

  // load normally if the entered url does not match an existing tab name
  if (!tabNames.includes(tabName)) {
    history.pushState("", "", window.location.pathname);
    return;
  }

  tabButtons.forEach((button) => {
    // const buttonText = button.querySelector("span").textContent.trim().toLowerCase();
    const buttonText = button.querySelector("span").textContent.trim();
    const buttonSlug = slugify(buttonText);
    button.classList.remove("fndry-tabs__nav-link--active", "fndry-tabs__tab-pane--show");

    if (buttonSlug === tabName) {
      button.classList.add("fndry-tabs__nav-link--active", "fndry-tabs__tab-pane--show");
      const activeIndex = button.getAttribute("data-tab-index");

      // Update tab panes
      tabPanes.forEach((pane) => {
        pane.classList.remove("fndry-tabs__tab-pane--active", "fndry-tabs__tab-pane--show");
        if (pane.getAttribute("data-tab-content-index") === activeIndex) {
          pane.classList.add("fndry-tabs__tab-pane--active", "fndry-tabs__tab-pane--show");
        }
      });
    }
  });
}

export default function initTabs() {
  const tabButtons = document.querySelectorAll('[data-fndry-js="nav-link"]');

  tabButtons.forEach((button) => {
    button.addEventListener("click", updateUrl);
  });

  window.addEventListener("hashchange", handleHashChange);
  // handle initial load if there's a hash in the URL
  if (window.location.hash) {
    handleHashChange();
  }
}
